export default () => {
  const userGlobals = {};

  const globals = Object.entries(window.$App.globals.user)
  globals.forEach((global) => (userGlobals[`$${global[0].toUpperCase()}`] = global[1]))

  return userGlobals
}